import { Typography } from 'Components/Typography';

import currencies from 'constants/currencies';

import backgroundImage from 'assets/images/skincare-minis-background-image.jpg';

import { formatPriceWithCurrency } from 'utils/currencies';

import * as flagVariants from 'dux/featureFlags/constants/flagVariants';

const content = {
  title: 'Skincare Starter Set',
  description: 'Free two-week, trial-size routine for morning and night.',
  backgroundImage: {
    src: backgroundImage,
    alt: '3 bottles of moisturizer, serum and cleanser. Natural sponge on the left side and a soap on a towel on the right',
  },
  stickerLabel: {
    [currencies.USD]: (
      <div>
        <Typography style={{ fontWeight: 500 }}>FREE</Typography>
        <Typography style={{ fontWeight: 300 }} variant="p3">
          {formatPriceWithCurrency({
            currency: currencies.USD,
            price: 65,
            minimumFractionDigits: 0,
          })}
          &nbsp;value
        </Typography>
      </div>
    ),
    [currencies.CAD]: (
      <Typography>
        <Typography style={{ fontWeight: 500 }}>FREE</Typography>
      </Typography>
    ),
  },
  modalButtonList: [
    { context: 'ingredients', label: 'Ingredients' },
    { context: 'routine', label: 'Instructions' },
  ],
  selectedContent: {
    [flagVariants.CONTROL]: {
      label: (
        <>
          Subscribe to Skincare with <b>FREE</b> Starter Set
        </>
      ),
      description: (
        <>
          Full-size orders ship every 4 weeks.
          <br />
          Edit your subscription or cancel anytime.
        </>
      ),
    },
    [flagVariants.VARIANT1]: {
      label: (
        <>
          Subscribe to Skincare with <b>FREE</b> Starter Set
        </>
      ),
      description: (
        <>
          Full-size orders ship every 8 weeks.
          <br />
          Edit your subscription or cancel anytime.
        </>
      ),
    },
  },
};

export default content;
